import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useUserAuth = () => {
  const { user, loading, clearUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    if (loading) return; // attendre la fin du chargement

    if (user) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
      clearUser(); // nettoyer le contexte
      navigate("/"); // rediriger vers la page de login
    }
  }, [user, loading, clearUser, navigate]);

  return { loading, authenticated, user };
};

export default useUserAuth;
